<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 9.44772 0.447715 9 1 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H1C0.447715 11 0 10.5523 0 10Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 2.44772 0.447715 2 1 2H19C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H1C0.447715 4 0 3.55228 0 3Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 17C0 16.4477 0.447715 16 1 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H1C0.447715 18 0 17.5523 0 17Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'IconBurger',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
